import { ReportConfig } from "../definitions";

const affiliatePaidProductionReport: ReportConfig = {
  id: "affiliatePaidProductionReport",
  name: "Affiliate Paid Production Report",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "${YEAR}-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "${YEAR}-${MONTH}-${DAY}" },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "YTD Production",
          widgetType: "table",
          columns: [
            { name: "", type: "string" },
            { name: "${YEAR-6}", type: "currency", summary: false, align: "right" },
            { name: "${YEAR-5}", type: "currency", summary: false, align: "right" },
            { name: "${YEAR-4}", type: "currency", summary: false, align: "right" },
            { name: "${YEAR-3}", type: "currency", summary: false, align: "right" },
            { name: "${YEAR-2}", type: "currency", summary: false, align: "right" },
            { name: "${YEAR-1}", type: "currency", summary: false, align: "right" },
            { name: "${YEAR}", type: "currency", summary: false, align: "right" },
          ],
          rowFormatter: [
            {
              which: -1,
              columns: [
                { name: "", type: "string" },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
              ],
            },
          ],
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());

WITH cte1 AS (
SELECT
    af.[ID] AS [AffID],
    af.[Name],
    YEAR(a.[PaidOrClosedDate]) as [PaidYear],
    ap.[AnnualizedPremium],
    CASE
        WHEN af.[Name] = 'Lion Street' THEN 1
        WHEN af.[Name] = 'Consolidated Marketing Group (CMG)' THEN 2
        ELSE 3
    END as [AffGroup]

FROM awu.Application a
    INNER JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    INNER JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
    LEFT JOIN dbo.Affiliate af on aa.AffiliateID = af.id

WHERE
    -- YEAR(a.[PaidOrClosedDate]) >= '2021'
    st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND aa.CommissionLevel = 1
    AND (a.IsDeleted = 0 OR a.IsDeleted IS NULL)
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
)

SELECT
    CASE
        WHEN [AffGroup] = 1 THEN 'Lion Street'
        WHEN [AffGroup] = 2 THEN 'Consolidated Marketing Group (CMG)'
        ELSE 'Independent Affiliates'
    END,
    SUM(IIF(a.[PaidYear] = @cy - 6, a.[AnnualizedPremium], 0)) AS [CY - 6],
    SUM(IIF(a.[PaidYear] = @cy - 5, a.[AnnualizedPremium], 0)) AS [CY - 5],
    SUM(IIF(a.[PaidYear] = @cy - 4, a.[AnnualizedPremium], 0)) AS [CY - 4],
    SUM(IIF(a.[PaidYear] = @cy - 3, a.[AnnualizedPremium], 0)) AS [CY - 3],
    SUM(IIF(a.[PaidYear] = @cy - 2, a.[AnnualizedPremium], 0)) AS [CY - 2],
    SUM(IIF(a.[PaidYear] = @cy - 1, a.[AnnualizedPremium], 0)) AS [CY - 1],
    SUM(IIF(a.[PaidYear] = @cy - 0, a.[AnnualizedPremium], 0)) AS [CY],
    [AffGroup] as [Section]
FROM cte1 AS a
GROUP BY [AffGroup]

UNION

SELECT
    'Total Affiliate Production',
    SUM(IIF(a.[PaidYear] = @cy - 6, a.[AnnualizedPremium], 0)) AS [CY - 6],
    SUM(IIF(a.[PaidYear] = @cy - 5, a.[AnnualizedPremium], 0)) AS [CY - 5],
    SUM(IIF(a.[PaidYear] = @cy - 4, a.[AnnualizedPremium], 0)) AS [CY - 4],
    SUM(IIF(a.[PaidYear] = @cy - 3, a.[AnnualizedPremium], 0)) AS [CY - 3],
    SUM(IIF(a.[PaidYear] = @cy - 2, a.[AnnualizedPremium], 0)) AS [CY - 2],
    SUM(IIF(a.[PaidYear] = @cy - 1, a.[AnnualizedPremium], 0)) AS [CY - 1],
    SUM(IIF(a.[PaidYear] = @cy - 0, a.[AnnualizedPremium], 0)) AS [CY],
    101 as [Section]
FROM cte1 AS a
WHERE [AffID] IS NOT NULL

UNION

SELECT
    'Total Paid Production',
    SUM(IIF(a.[PaidYear] = @cy - 6, a.[AnnualizedPremium], 0)) AS [CY - 6],
    SUM(IIF(a.[PaidYear] = @cy - 5, a.[AnnualizedPremium], 0)) AS [CY - 5],
    SUM(IIF(a.[PaidYear] = @cy - 4, a.[AnnualizedPremium], 0)) AS [CY - 4],
    SUM(IIF(a.[PaidYear] = @cy - 3, a.[AnnualizedPremium], 0)) AS [CY - 3],
    SUM(IIF(a.[PaidYear] = @cy - 2, a.[AnnualizedPremium], 0)) AS [CY - 2],
    SUM(IIF(a.[PaidYear] = @cy - 1, a.[AnnualizedPremium], 0)) AS [CY - 1],
    SUM(IIF(a.[PaidYear] = @cy - 0, a.[AnnualizedPremium], 0)) AS [CY],
    102 as [Section]
FROM cte1 AS a

UNION

SELECT
    '% Of Total Paid Production',
    SUM(IIF(a.[PaidYear] = @cy - 6 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 6, a.[AnnualizedPremium], 0)) AS [CY - 6],
    SUM(IIF(a.[PaidYear] = @cy - 5 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 5, a.[AnnualizedPremium], 0)) AS [CY - 5],
    SUM(IIF(a.[PaidYear] = @cy - 4 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 4, a.[AnnualizedPremium], 0)) AS [CY - 4],
    SUM(IIF(a.[PaidYear] = @cy - 3 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 3, a.[AnnualizedPremium], 0)) AS [CY - 3],
    SUM(IIF(a.[PaidYear] = @cy - 2 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 2, a.[AnnualizedPremium], 0)) AS [CY - 2],
    SUM(IIF(a.[PaidYear] = @cy - 1 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 1, a.[AnnualizedPremium], 0)) AS [CY - 1],
    SUM(IIF(a.[PaidYear] = @cy - 0 AND a.[AffID] IS NOT NULL, a.[AnnualizedPremium], 0)) /
    SUM(IIF(a.[PaidYear] = @cy - 0, a.[AnnualizedPremium], 0)) AS [CY],
    103 as [Section]
FROM cte1 AS a

ORDER BY [Section]`,
            returnType: "table",
          },
          options: { summary: true },
        },
      ],
    },
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Affiliate", type: "string" },
            { name: "Policies", type: "string" },
            { name: "Paid", type: "currency", summary: "sum", align: "right" },
          ],
          dataSource: {
            sql: `
SELECT ISNULL(af.[Name], 'NULL Affiliate'),
    COUNT(a.ID),
    SUM(ap.[AnnualizedPremium]) as [Paid]
FROM awu.Application a
    INNER JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    INNER JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
    INNER JOIN dbo.Affiliate af on aa.AffiliateID = af.id

WHERE a.PaidOrClosedDate BETWEEN @startDate AND @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND aa.CommissionLevel = 1
    AND (a.IsDeleted = 0 OR a.IsDeleted IS NULL)
    AND (af.IsDeleted = 0 OR af.IsDeleted IS NULL)
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)

GROUP BY af.[Name]
ORDER BY [Paid] DESC
            `,
            returnType: "table",
          },
          options: { summary: true },
        },
      ],
    },
  ],
};

export default affiliatePaidProductionReport;
